<template>
  <div class="dg-dateFilter">
    <b-dropdown v-if="!type" text="Choose filter type" variant="link">
      <b-dropdown-item @click="showFilterType('on')">On</b-dropdown-item>
      <b-dropdown-item @click="showFilterType('onOrAfter')">On or after</b-dropdown-item>
      <b-dropdown-item @click="showFilterType('after')">After</b-dropdown-item>
      <b-dropdown-item @click="showFilterType('onOrBefore')">On or before</b-dropdown-item>
      <b-dropdown-item @click="showFilterType('before')">Before</b-dropdown-item>
      <b-dropdown-item @click="showFilterType('between')">Between</b-dropdown-item>
    </b-dropdown>
    <div v-else>
      <div class="dg-datePicker _between" v-if="type === 'between'">
        <span>
          <div class="dg-datePicker__value">
            <span
              class="dg-datePicker__triggerWrapper"
              bv-click-outside="closeDatepicker('datePicker1')"
            >
              <input
                v-if="isExpressionMode"
                class="form-control input-sm"
                v-model="date1"
                @change="selectDate1(date1)"
                placeholder="Expression"
              />
              <a
                v-else
                href="#"
                class="dg-datePicker__trigger"
                @click.prevent="openDatepicker('datePicker1')"
                @keydown.enter="openDatepicker('datePicker1')"
              >
                <span v-if="date1">{{ date1 | moment("MM/DD/YYYY") }}</span>
                <span v-else>Select</span>
              </a>
            </span>
          </div>
          <div class="dg-datePicker__input">
            <DatePicker
              ref="datePicker1"
              :value="date1 || new Date(Date.now())"
              @selected="selectDate1"
            />
          </div>
        </span>
        <span>-</span>
        <span>
          <div class="dg-datePicker__value">
            <span
              class="dg-datePicker__triggerWrapper"
              bv-click-outside="closeDatepicker('datePicker2')"
            >
              <input
                v-if="isExpressionMode"
                class="form-control input-sm"
                v-model="date2"
                @change="selectDate2(date2)"
                placeholder="Expression"
              />
              <a
                v-else
                href="#"
                class="dg-datePicker__trigger"
                @click.prevent="openDatepicker('datePicker2')"
                @keydown.enter="openDatepicker('datePicker2')"
              >
                <span v-if="date2">{{ date2 | moment("MM/DD/YYYY") }}</span>
                <span v-else>Select</span>
              </a>
            </span>
          </div>
          <div class="dg-datePicker__input">
            <DatePicker
              ref="datePicker2"
              :value="date2 || new Date(Date.now())"
              @selected="selectDate2"
            />
          </div>
        </span>
      </div>
      <div v-else>
        <div class="dg-datePicker">
          <div class="dg-datePicker__value">
            <span
              class="dg-datePicker__triggerWrapper"
              bv-click-outside="closeDatepicker('singleDatepicker')"
            >
              <input
                v-if="isExpressionMode"
                class="form-control input-sm"
                v-model="singleDate"
                @change="selectSingleDate(singleDate)"
                placeholder="Expression"
              />
              <a
                v-else
                href="#"
                class="dg-datePicker__trigger"
                @click.prevent="openDatepicker('singleDatepicker')"
                @keydown.enter="openDatepicker('singleDatepicker')"
              >
                <span v-if="singleDate">{{ singleDate | moment("MM/DD/YYYY") }}</span>
                <span v-else>Select</span>
              </a>
            </span>
          </div>
          <div v-if="!isExpressionMode" class="dg-datePicker__input">
            <DatePicker
              ref="singleDatepicker"
              :value="singleDate || new Date(Date.now())"
              @selected="selectSingleDate"
            />
          </div>
        </div>
      </div>
      <button
        v-if="isComputedExpression"
        class="btn btn-sm btn__toggle-expression"
        :class="{ 'btn-primary': isExpressionMode }"
        @click="toggleExpression()"
      >
        <icon name="code" />
      </button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import utils from '@/helpers/utils'

export default {
  props: ['cellKey', 'filter', 'isComputedExpression'],
  data() {
    return {
      type: null,
      condition: null,
      singleDate: null,
      date1: null,
      date2: null,
      isExpressionMode: false,
    }
  },
  watch: {
    condition() {
      if (condition) console.log(`let's filter it`)
    },
  },
  mounted() {
    const currentFilter = this.filter && this.filter[this.cellKey]
    if (currentFilter) {
      const { type, date, date1, date2, expression } = currentFilter
      this.type = type
      if (!this.isComputedExpression && expression) {
        this.singleDate = utils.evalExpression(date)
        this.date1 = utils.evalExpression(date1)
        this.date2 = utils.evalExpression(date2)
      } else {
        this.singleDate = date
        this.date1 = date1
        this.date2 = date2
      }
      this.isExpressionMode = this.isComputedExpression && expression
    }
  },
  methods: {
    showFilterType(type) {
      this.date1 = null
      this.date2 = null
      this.singleDate = null

      this.type = type
      Vue.set(this.filter, this.cellKey, null)
    },
    openDatepicker(datePicker) {
      this.$nextTick(() => {
        this.$refs[datePicker].showCalendar()
      })
    },
    closeDatepicker(datePicker) {
      this.$nextTick(() => {
        this.$refs[datePicker].close()
      })
    },
    selectSingleDate(date) {
      const vm = this

      this.singleDate = date

      Vue.set(this.filter, this.cellKey, {
        type: vm.type,
        date: vm.singleDate,
        expression: this.isExpressionMode,
      })
    },
    selectDate1(date) {
      const vm = this

      this.date1 = date

      if (!this.filter[this.cellKey])
        Vue.set(this.filter, this.cellKey, { type: vm.type })

      Vue.set(this.filter[this.cellKey], 'date1', date)
      Vue.set(this.filter[this.cellKey], 'date2', this.date2)
      Vue.set(this.filter[this.cellKey], 'expression', this.isExpressionMode)
    },
    selectDate2(date) {
      const vm = this

      this.date2 = date

      if (!this.filter[this.cellKey])
        Vue.set(this.filter, this.cellKey, { type: vm.type })

      Vue.set(this.filter[this.cellKey], 'date1', this.date1)
      Vue.set(this.filter[this.cellKey], 'date2', date)
      Vue.set(this.filter[this.cellKey], 'expression', this.isExpressionMode)
    },
    toggleExpression() {
      this.isExpressionMode = !this.isExpressionMode
      this.singleDate = null
      this.date1 = null
      this.date2 = null
    },
  },
  created() {
    this.$parent.$on('filterItemRemove', cellKey => {
      this.type = null
    })
  },
}
</script>

<style lang="scss">
.dg-dateFilter {
  white-space: normal;
  padding-top: 9px;
  .dg-datePicker {
    &._between > span {
      display: inline-block;
    }
    &__trigger,
    &__value {
      font-weight: normal;
    }
  }
}
.btn {
  &__toggle-expression {
    position: absolute;
    right: 0;
    top: 6px;
  }
}
</style>
